import { selectUserFavorites, updateFavorites } from 'containers/Login/loginSlice'
import { useReduxDispatch, useReduxSelector } from 'store'
import useTranslation from 'hooks/useTranslation'
import { useHistory } from 'react-router-dom'
import Popup from 'components/popups/Popup'
import React, { useState } from 'react'
import { POST } from 'rest/request'
import * as urls from 'rest/urls'

interface RemoveFavoritePopupProps {
  relatedId: string
}

const RemoveFavoritePopup: React.FC<RemoveFavoritePopupProps> = ({ relatedId }) => {
  const favorites = useReduxSelector(selectUserFavorites)
  const [isSending, setSending] = useState(false)

  const { goBack } = useHistory()
  const { t } = useTranslation('dashboard')
  const dispatch = useReduxDispatch()

  const removeAction = async () => {
    if (isSending) return
    setSending(true)
    try {
      const warehouseIds = (favorites as any[]).reduce((r, f) => {
        if (f.related.id !== relatedId) {
          r.push(f.related.id)
        }
        return r
      }, [])
      const response = await POST(urls.favorites, { body: { warehouseIds } })
      if (response.success && response.data) {
        dispatch(updateFavorites(response.data))
        goBack()
      } else {
        throw new Error()
      }
    } catch (error) {
      setSending(false)
    }
  }

  return (
    <Popup>
      <div className='popup__basket--warning popup__removeFavorite'>
        <div className='popup__title'>
          <div>{t('caution')}</div>
          <div>{t('storageNotRented')}<br />{t('removeShortcut')}</div>
        </div>

        <div className='popup__buttons group'>
          <div
            className='button --cancel'
            onClick={goBack}>{t('no')}</div>

          <div
            className='button --accept'
            onClick={removeAction}>{t(isSending ? 'saving' : 'yes')}</div>
        </div>
      </div>
    </Popup>
  )
}

export default RemoveFavoritePopup